import GOActivation from './GOActivation'

export { GOActivation }
